import React from 'react'
import Icons from '../../assets/icons'
import LanguageTranslator from '../../locals/LanguageTranslator'
import { TriangleAlert } from 'lucide-react'

const UploadExcelInfo = () => {
    return (
        // <div className='uehr-info p-[5px] relative group'>
        //     <Icons.InfoIcon />
        //     <div 
        //         className='uehr-dropdown absolute top-0 right-[23px] z-[9] min-w-[190px] w-auto rounded-md bg-white invisible opacity-0 transition-all duration-500 group-hover:visible group-hover:opacity-100'
        //         style={{
        //             boxShadow: '2px 3px 6px 0 rgba(0, 0, 0, .16)'
        //         }}
        //     >
        //         <ul>
        //             <li className='py-[5px] px-2.5 text-xs font-medium whitespace-nowrap italic cursor-default'>
        //                 <label className="generic-checkbox">
        //                     <input type="checkBox" checked={true} />
        //                     <span className="checkmark1 mandateFieldsColor"></span>
        //                     <LanguageTranslator>Grey: Mandatory fields</LanguageTranslator>
        //                 </label>
        //             </li>
        //             <li className='py-[5px] px-2.5 text-xs font-medium whitespace-nowrap italic cursor-default'>
        //                 <label className="generic-checkbox">
        //                     <input type="checkBox" checked={true} />
        //                     <span className="checkmark1 dataIssueFieldsColor"></span>
        //                     <LanguageTranslator>Orange: Data Issue fields</LanguageTranslator>
        //                 </label>
        //             </li>
        //             <li className='py-[5px] px-2.5 text-xs font-medium whitespace-nowrap italic cursor-default'>
        //                 <label className="generic-checkbox">
        //                     <input type="checkBox" checked={true} />
        //                     <span className="checkmark1 mismatchedFieldsColor"></span>
        //                     <LanguageTranslator>Red: Mismatched fields</LanguageTranslator>
        //                 </label>
        //             </li>
        //             <li className='py-[5px] px-2.5 text-xs font-medium whitespace-nowrap italic cursor-default'>
        //                 <label className="generic-checkbox">
        //                     <input type="checkBox" checked={true} />
        //                     <span className="checkmark1 extinctFieldsColor"></span>
        //                     <LanguageTranslator>Yellow: Extinct fields</LanguageTranslator>
        //                 </label>
        //             </li>
        //             <LanguageTranslator tag='li' className='py-[5px] px-2.5 text-xs font-medium whitespace-nowrap italic cursor-default'>*Contact Supplymint for more info...</LanguageTranslator>
        //         </ul>
        //     </div>
        // </div>
        <div className='uehr-info p-[5px] relative group'>
            <Icons.InfoIcon width={15} />
            <div 
                className='uehr-dropdown absolute top-0 right-[23px] z-[9] min-w-[120px] w-auto rounded-md bg-white invisible opacity-0 transition-all duration-500 pointer-events-none group-hover:pointer-events-auto group-hover:visible group-hover:opacity-100'
                style={{
                    boxShadow: '2px 3px 6px 0 rgba(0, 0, 0, .16)'
                }}
            >
                <div className='px-3 py-[5px] border-b border-borderSlateGrey flex items-center gap-2'>
                    <TriangleAlert strokeWidth={2.25} size={17} className='shrink-0' color='#FD3757'/>
                    <p className='mb-0 text-[13px] font-semibold'>Error Types</p>
                </div>
                <div className='px-1.5 py-1.5 space-y-1.5'>
                    <div className='px-2 py-1.5 flex items-center gap-1.5 rounded-[5px] bg-[#55555533]'>
                        <div className='h-[6px] w-[6px] shrink-0 rounded-full bg-[#555555]'></div>
                        <p className='mb-0 text-[11px]'>Mandatory Issue</p>
                    </div>
                    <div className='px-2 py-1.5 flex items-center gap-1.5 rounded-[5px] bg-[#E1705533]'>
                        <div className='h-[6px] w-[6px] shrink-0 rounded-full bg-[#E17055]'></div>
                        <p className='mb-0 text-[11px]'>Data Issue Fields</p>
                    </div>
                    <div className='px-2 py-1.5 flex items-center gap-1.5 rounded-[5px] bg-[#D6303133]'>
                        <div className='h-[6px] w-[6px] shrink-0 rounded-full bg-[#D63031]'></div>
                        <p className='mb-0 text-[11px]'>Mismatched Fields</p>
                    </div>
                    <div className='px-2 py-1.5 flex items-center gap-1.5 rounded-[5px] bg-[#FFB93633]'>
                        <div className='h-[6px] w-[6px] shrink-0 rounded-full bg-[#FFB936]'></div>
                        <p className='mb-0 text-[11px]'>Extinct Fields</p>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default UploadExcelInfo